// alternative-dashboard\mappers\topBeneficiariesMapper.ts
import type {
  TopBenificiariesGraphResponse,
  TopBeneficiaryDisplayItem,
} from "../types/topBeneficiaries";

export const mapTopBeneficiariesResponse = (
  items: TopBenificiariesGraphResponse[],
): TopBeneficiaryDisplayItem[] => {
  const withAmounts = items.map((item) => {
    const latestMonth = item.months[item.months.length - 1];

    return {
      id: `${item.beneId}-${item.beneAccountName}`,
      name: item.beneAccountName,
      amount: latestMonth?.totalAmount ?? 0,
      currency: latestMonth?.debitCurrency ?? "AED",
      count: latestMonth?.count ?? 0,
    };
  });

  const maxAmount = Math.max(...withAmounts.map((i) => i.amount), 0);

  return withAmounts
    .map((item) => ({
      ...item,
      percentage:
        maxAmount > 0 ? Math.round((item.amount / maxAmount) * 100) : 0,
    }))
    .sort((a, b) => b.amount - a.amount);
};
